import script from "./SmallBasket.vue?vue&type=script&lang=ts&setup=true"
export * from "./SmallBasket.vue?vue&type=script&lang=ts&setup=true"

import "./SmallBasket.vue?vue&type=style&index=0&id=71189469&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71189469"]])

export default __exports__